module.exports = __webpack_public_path__ + "img/0Q3A2361_L_Foamcore.a2085380.jpg";